package se.mittpass.web

import se.mittpass.web.*
import se.mittpass.web.components.*
import se.mittpass.web.pages.*
import se.mittpass.web.viewmodel.*
import se.mittpass.web.style.*


import androidx.compose.runtime.*
import kotlinx.browser.localStorage
import kotlinx.browser.document
import se.mittpass.shared.translation.Language
import se.mittpass.shared.translation.Dictionary
import se.mittpass.shared.translation.SwedishDictionary
import se.mittpass.shared.translation.EnglishDictionary
import se.mittpass.shared.translation.ArabicDictionary
import se.mittpass.shared.translation.GermanDictionary

object LocaleManager {
    private const val STORAGE_KEY = "mittpass_lang"
    
    var currentLanguage by mutableStateOf(Language.SV)
        private set

    val dictionary: Dictionary
        get() = when (currentLanguage) {
            Language.SV -> SwedishDictionary
            Language.EN -> EnglishDictionary
            Language.AR -> ArabicDictionary
            Language.DE -> GermanDictionary
        }

    fun init() {
        val saved = localStorage.getItem(STORAGE_KEY)
        val initialLang = Language.fromCode(saved)
        setLanguage(initialLang)
    }

    fun setLanguage(language: Language) {
        currentLanguage = language
        localStorage.setItem(STORAGE_KEY, language.code)
        
        // Dynamic HTML Direction for RTL support (Arabic)
        val dir = if (language.isRtl) "rtl" else "ltr"
        document.documentElement?.setAttribute("dir", dir)
        document.documentElement?.setAttribute("lang", language.code)
    }

    fun getEnglishTitle(path: String): String {
        return when {
            path == "/" -> "Landing Page"
            path.startsWith("/app") -> "Dashboard"
            path == "/personalliggare" -> "Staff Register"
            path == "/schemalagga-personal" || path == "/schemalaggning" -> "Scheduling"
            path == "/egenkontroll" -> "Food Safety"
            path == "/livsmedelskontroll" -> "Food Control Inspection"
            path == "/haccp" -> "HACCP System"
            path == "/privacy" -> "Privacy Policy"
            path == "/terms" -> "Terms of Service"
            path == "/dpa" -> "Data Processing Agreement"
            path == "/delete-account" -> "Account Deletion"
            path == "/support" -> "App Support"
            else -> "Unknown"
        }
    }
}
